const storageTypes = {
    sessionStorage: 'sessionStorage',
    localStorage: 'localStorage',
};

export function setStorageItem(key, value, storageType) {
    if(!storageTypes[storageType] || !key || !value) {
        return;
    }

   return window[storageType].setItem(key, JSON.stringify(value));
}

export function getStorageItem(key, storageType) {
    if(!storageTypes[storageType] || !key) {
        return;
    }

   return JSON.parse(window[storageType].getItem(key));
}

export function removeStorageItem(key, storageType) {
    if(!storageTypes[storageType] || !key) {
        return;
    }
    return window[storageType].removeItem(key);
}